import React from 'react';
import ReactDOM from 'react-dom/client';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { Capacitor } from '@capacitor/core';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const isNative = Capacitor.isNativePlatform();
console.log('[CENTRIS] isNative:', isNative, '| protocol:', window.location.protocol, '| platform:', Capacitor.getPlatform());

class ErrorBoundary extends React.Component {
  constructor(props) { super(props); this.state = { error: null }; }
  static getDerivedStateFromError(e) { return { error: e?.message || String(e), stack: e?.stack || '' }; }
  componentDidCatch(error, info) { console.error('React render error:', error, info); }
  render() {
    if (this.state.error) {
      return (
        <div style={{ position: 'fixed', inset: 0, background: '#0f0f0f', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: 24, overflowY: 'auto' }}>
          <p style={{ color: '#f87171', fontFamily: 'monospace', fontSize: 13, textAlign: 'center', marginBottom: 12 }}>App crashed — tap to reload</p>
          <pre style={{ color: '#fbbf24', fontFamily: 'monospace', fontSize: 10, textAlign: 'left', background: '#1a1a1a', padding: 16, borderRadius: 8, maxWidth: '90vw', overflowX: 'auto', whiteSpace: 'pre-wrap' }}>{this.state.error}{'\n\n'}{this.state.stack}</pre>
          <button onClick={() => window.location.reload()} style={{ marginTop: 20, padding: '10px 24px', background: '#6366f1', color: '#fff', border: 'none', borderRadius: 8, fontSize: 14, cursor: 'pointer' }}>Reload App</button>
        </div>
      );
    }
    return this.props.children;
  }
}

// Google OAuth Client ID - move to .env file as REACT_APP_GOOGLE_CLIENT_ID
const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID || '208888558593-obqvqf5h76ikdl6iv3irs6d063dkle0g.apps.googleusercontent.com';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <ErrorBoundary>
    {isNative ? (
      // In Capacitor: skip GoogleOAuthProvider entirely so GIS script never loads.
      // GIS's dynamic script injection crashes WKWebView with "_onload is not a function".
      // GmailSubscriptionScanner (which calls useGoogleLogin) is guarded to return null in Capacitor.
      <App />
    ) : (
      <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
        <App />
      </GoogleOAuthProvider>
    )}
  </ErrorBoundary>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
